<template>
  <VisaForm country="india" :products>
    <template #visa_select="{ form }">
      <BasketFields :form :products />
      <EntryFields
        v-model="form.entry"
        :date-hint="getEntryDateHint(form.product)"
        has-port
      />
      <TermsCheckbox v-model="form.termsAgreed" />
    </template>

    <template #details="{ form }">
      <ClientFields v-model="form.client" />
      <BusinessFields v-if="isBusiness(form.product)" v-model="form.business" />
      <PassportDetailsNotes year-valid-and-two-empty-pages />
      <LazyApplicantInfo
        v-for="(applicant, i) in form.applicants"
        :applicant="applicant"
        :index="i"
      >
        <template #passport>
          <PassportFields v-model="applicant.passport" />
        </template>
        <template #personal>
          <ExtraNationalityFieldsIndia v-model="applicant.extraNationality" />
          <FormBlock>
            <AppRow>
              <IdNumberField v-model="applicant.idNumber" />
              <ReligionSelect v-model="applicant.religion" />
            </AppRow>
          </FormBlock>
          <FormBlock>
            <AddressFields v-model="applicant.address" />
          </FormBlock>
          <CrimeFields v-model="applicant.crime" />
        </template>
        <template #family>
          <FamilyDetailsFields v-model="applicant.family" has-parents-birth-country has-spouse-fields />
        </template>
        <template #occupation>
          <OccupationFields
            v-model="applicant.occupation"
            :hide-details="isBusiness(form.product)"
            has-address has-education
          />
          <MilitaryFields v-model="applicant.military" />
        </template>
        <template #pastTravels>
          <PastTravelsFields v-model="applicant.pastTravels" has-visa-date saarc />
        </template>
      </LazyApplicantInfo>
    </template>

    <template #review />
    <template #upload />
    <template #payment />
  </VisaForm>
</template>

<script setup lang="ts">
import { isBusiness } from '~/helpers/product';
import type { Product } from '~/types';

defineProps<{
  products: Product[];
}>();

const { tt } = useLocalization();
function getEntryDateHint(product: Product) {
  switch (product.name) {
    case 'india_tourist_year':
    case 'india_business_year': return tt('estimate_entry_date_year_valid');
    case 'india_tourist_5_years': return tt('estimate_entry_date_5_years_valid');
  }
}
</script>